<div class="modal-header">
  <h4 class="modal-title">{{ 'chat.contextRef.pickerTitle' | translate }}</h4>
  <button type="button" class="btn-close" [attr.aria-label]="'chat.contextRef.cancel' | translate" (click)="close()"></button>
</div>

<div class="modal-body">
  <p class="text-muted mb-2">{{ 'chat.contextRef.pickerHint' | translate }}</p>

  <!-- Kind tabs -->
  <ul class="nav nav-pills nav-justified mb-2">
    <li class="nav-item">
      <a
        href="javascript:void(0);"
        class="nav-link"
        [class.active]="activeKind === kinds.ATTENDANCE"
        (click)="selectKind(kinds.ATTENDANCE)"
      >
        <i class="ri-customer-service-2-line me-1"></i>{{ 'chat.contextRef.kindAttendance' | translate }}
      </a>
    </li>
    <li class="nav-item">
      <a
        href="javascript:void(0);"
        class="nav-link"
        [class.active]="activeKind === kinds.CARD"
        (click)="selectKind(kinds.CARD)"
      >
        <i class="ri-price-tag-3-line me-1"></i>{{ 'chat.contextRef.kindCard' | translate }}
      </a>
    </li>
    <li class="nav-item">
      <a
        href="javascript:void(0);"
        class="nav-link"
        [class.active]="activeKind === kinds.CONTACT"
        (click)="selectKind(kinds.CONTACT)"
      >
        <i class="ri-user-3-line me-1"></i>{{ 'chat.contextRef.kindContact' | translate }}
      </a>
    </li>
  </ul>

  <div class="mb-2 d-flex gap-2">
    <input
      type="text"
      class="form-control"
      name="chatContextRefTerm"
      [placeholder]="'chat.contextRef.searchPlaceholder' | translate"
      [attr.aria-label]="'chat.contextRef.searchPlaceholder' | translate"
      [(ngModel)]="term"
      (input)="search()"
    >
    <!-- Attendance status filter — rides the pager's `status` param. -->
    @if (activeKind === kinds.ATTENDANCE) {
      <select
        class="form-select chat-context-ref-status flex-shrink-0"
        name="chatContextRefStatus"
        [attr.aria-label]="'chat.contextRef.statusFilter' | translate"
        [(ngModel)]="statusFilter"
        (ngModelChange)="search()"
      >
        <option value="">{{ 'chat.contextRef.statusAll' | translate }}</option>
        @for (option of statusOptions; track option.value) {
          <option [value]="option.value">{{ option.labelKey | translate }}</option>
        }
      </select>
    }
  </div>

  @if (loading) {
    <div class="d-flex flex-column align-items-center justify-content-center gap-2 py-4">
      <div class="spinner-border text-primary" role="status"></div>
      <span class="text-muted">{{ 'chat.contextRef.loading' | translate }}</span>
    </div>
  } @else if (hasError) {
    <div class="d-flex flex-column align-items-center justify-content-center gap-2 py-4 text-center">
      <i class="ri-error-warning-line font-24 text-danger"></i>
      <span class="text-muted">{{ 'chat.contextRef.loadError' | translate }}</span>
      <button type="button" class="btn btn-sm btn-soft-primary" (click)="search()">
        {{ 'chat.contextRef.retry' | translate }}
      </button>
    </div>
  } @else if (options.length === 0) {
    <div class="d-flex flex-column align-items-center justify-content-center gap-2 py-4 text-center">
      <div class="avatar-sm rounded-circle bg-soft-primary">
        <i class="avatar-title text-primary font-18" [ngClass]="kindIcon"></i>
      </div>
      <span class="text-muted">{{ 'chat.contextRef.empty' | translate }}</span>
      <small class="text-muted">{{ 'chat.contextRef.emptyHint' | translate }}</small>
    </div>
  } @else {
    <div class="list-group list-group-flush chat-context-ref-list overflow-auto">
      @for (option of options; track trackOption($index, option)) {
        <button
          type="button"
          class="list-group-item list-group-item-action d-flex align-items-center gap-2 py-2"
          (click)="choose(option)"
        >
          <span class="avatar-xs rounded bg-soft-primary flex-shrink-0">
            <i class="avatar-title text-primary font-16" [ngClass]="kindIcon"></i>
          </span>
          <span class="flex-grow-1 overflow-hidden text-start">
            <span class="d-block text-truncate fw-semibold">{{ option.label }}</span>
            @if (option.subtitle) {
              <small class="text-muted d-block text-truncate">{{ option.subtitle }}</small>
            }
          </span>
          <!-- Attendance status — display-only badge, never persisted. -->
          @if (option.statusKey) {
            <span class="badge bg-soft-primary text-primary flex-shrink-0">
              {{ option.statusKey | translate }}
            </span>
          }
          <i class="ri-arrow-right-line text-muted flex-shrink-0"></i>
        </button>
      }
    </div>

    <!-- Server pagination (attendances/contacts — cards answer a plain list). -->
    @if (pager && pager.total > pager.perPage) {
      <nav class="d-flex justify-content-between align-items-center mt-2" [attr.aria-label]="'chat.contextRef.pagination' | translate">
        <small class="text-muted">{{ 'chat.contextRef.pageOf' | translate: { page: page, pages: pageCount } }}</small>
        <ul class="pagination pagination-rounded mb-0">
          <li class="page-item" [class.disabled]="page <= 1">
            <button type="button" class="page-link" [disabled]="page <= 1" (click)="onPager(page - 1)"
              [attr.aria-label]="'chat.contextRef.previousPage' | translate">
              <i class="ri-arrow-left-s-line"></i>
            </button>
          </li>
          <li class="page-item" [class.disabled]="page >= pageCount">
            <button type="button" class="page-link" [disabled]="page >= pageCount" (click)="onPager(page + 1)"
              [attr.aria-label]="'chat.contextRef.nextPage' | translate">
              <i class="ri-arrow-right-s-line"></i>
            </button>
          </li>
        </ul>
      </nav>
    }
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="close()">{{ 'chat.contextRef.cancel' | translate }}</button>
</div>
